const ArrowRightIcon = () => {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7803 6.24219L7.96783 10.8359C7.6944 11.082 7.28424 11.082 7.03815 10.8086C6.79205 10.5352 6.79205 10.125 7.06549 9.87891L10.7022 6.40625H1.40533C1.02252 6.40625 0.749084 6.13281 0.749084 5.75C0.749084 5.39453 1.02252 5.09375 1.40533 5.09375H10.7022L7.06549 1.64844C6.79205 1.40234 6.79205 0.964844 7.03815 0.71875C7.28424 0.445312 7.72174 0.445312 7.96783 0.691406L12.7803 5.28516C12.9171 5.42188 12.9991 5.58594 12.9991 5.75C12.9991 5.94141 12.9171 6.10547 12.7803 6.24219Z"
        fill="white"
      />
    </svg>
  )
}

export default ArrowRightIcon
